/* eslint-disable no-unused-vars */
import { FormFieldOption } from './formFieldOption'
import { QuestionFormField, QuestionFormFieldType } from './questionFormField'

/**
 * Creates an instance of FormFieldOption.
 * @typedef {Object} QuestionFormFieldWithOptionsType
 * @property {FormFieldOption[]} options
 *
 * @typedef {QuestionFormFieldType & QuestionFormFieldWithOptionsType} QuestionFormFieldWithOptionsExtendType
 */

/**
 * Represents a question form field with options.
 * @class
 */
export class QuestionFormFieldWithOptions extends QuestionFormField {
  /**
   * Create a new QuestionFormFieldWithOptions.
   * @param {QuestionFormFieldWithOptionsExtendType} params
   */
  constructor(params) {
    super(params)
    this.options =
      params.options.length > 0
        ? params.options.map((field) => new FormFieldOption(field))
        : []
  }
}
